import React from 'react';
import { Button, Box } from '@mui/material';
import useNavbarStyles from '../navbarStyles';
import { useHandleClick } from '../../../utils/clickHandlers';

//navbar in bigger screens (without collapsing)
const DefaultNavbar = ({ isScrolled }) => {
    const classes = useNavbarStyles();
    const handleClick = useHandleClick();

  return (
    <Box className={classes.defaultNavbarContainer}>
        {/* Navbar Buttons */}
        <Box className={classes.buttonGroup}>
            <Button className={isScrolled ? classes.navButtonDark : classes.navButtonWhite} onClick={(event) => handleClick(event, 'project')}>
                Paket Visions
            </Button>
            <Button className={isScrolled ? classes.navButtonDark : classes.navButtonWhite} onClick={(event) => handleClick(event,'viewerToggle')}>
                Model Viewer
            </Button>
            <Button className={isScrolled ? classes.navButtonDark : classes.navButtonWhite}
            onClick={(event) => handleClick(event,'about-us')}>
               About Us
            </Button>
        </Box>
        <div className={classes.placeholder}></div>

    </Box>

  );
};

export default DefaultNavbar;